<template>
    <div class="guests">
        <div class="content">
            <h2>Naši gostje</h2>
        </div>
		<div class="gallery-wrapper" v-if="this.gallery.length < 5">
			<div class="image-item" v-for="gallery_item in gallery" :key="gallery_item">
				<div class="image-ratio">
					<img v-bind:src="gallery_item.path">          
				</div>
			</div>
		</div>
		<VueSlickCarousel :arrows="false" :dots="true" v-if="this.gallery.length >= 5" v-bind="settings">
			<div class="image-item" v-for="gallery_item in gallery" :key="gallery_item">
				<div class="image-ratio">
					<img v-bind:src="gallery_item.path">          
				</div>
			</div>
		</VueSlickCarousel>
		<div class="content">
			<div class="testimonials-wrapper">
				<div class="testimonial" v-for="testimonial in testimonials" :key="testimonial">
					<div class="quote"></div>
					<h4>{{ testimonial.name }}</h4>
					<div class="rating"></div>
					<p>{{ testimonial.message }}</p>
				</div>
			</div>
	</div>
    </div>
</template>

<style lang="scss">
@import 'guests.scss';
</style>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
	props: ['testimonials', 'gallery'],
	components: {
		VueSlickCarousel
	},
	data: () => ({
		settings: {
            "arrows": false,
            "dots": true,
            "dotsClass": "slick-dots custom-dot-class",
            "edgeFriction": 0.35,
            "infinite": false,
            "speed": 500,
            "slidesToShow": 5,
			"slidesToScroll": 4,
			"responsive": [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },

            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 639,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
               
              }
            }
            ]
        }
	})
	// computed: {
	// 	gallery() {
	// 		return this.$store.getters.allGalleryPizzas
	// 	},
	// },
	// mounted() {
	// 	this.$store.dispatch("getGalleryPizzas")
	// },
};
</script>